import { render } from "./CalendarIcon.vue?vue&type=template&id=1eb4f9b8&scoped=true"
const script = {}

import "./CalendarIcon.vue?vue&type=style&index=0&id=1eb4f9b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb4f9b8"]])

export default __exports__